import { ELocalStorageKey } from '/@/types'

const WEB_SESSION_KEYS = [
  ELocalStorageKey.Username,
  ELocalStorageKey.WorkspaceId,
  ELocalStorageKey.Token,
  ELocalStorageKey.PlatformName,
  ELocalStorageKey.WorkspaceName,
  ELocalStorageKey.WorkspaceDesc,
  ELocalStorageKey.Flag,
  ELocalStorageKey.UserId,
  ELocalStorageKey.Device,
  ELocalStorageKey.GatewayOnline,
]

export function hasWebSession () {
  return !!localStorage.getItem(ELocalStorageKey.Token)
}

export function clearWebSession () {
  WEB_SESSION_KEYS.forEach(key => localStorage.removeItem(key))
}
